export enum EventType {
    NavigateOutCriterion,
    SaveAnalysis
}
